export default __webpack_public_path__ + "static/media/OolaGlobalCompPlan.a615f59a.pdf";